import { useState, useEffect } from 'react';
import SocialMediaItem from './SocialMediaItem';

import './SocialMedia.css';

const socialMedia = [
  {
    name: 'GitHub',
    img: 'GitHub-Mark-Light-64px.png',
    alt: 'Github Icon',
    url: 'https://github.com/marianopedrini',
  },
  {
    name: 'Linkedin',
    img: 'linkedin-whitex64.png',
    alt: 'Linkedin Icon',
    url: 'https://www.linkedin.com/in/mariano-pedrini-1a6a701a6/',
  },
  {
    name: 'Email',
    img: 'mail-whitex64.png',
    alt: 'Email Icon',
    url: 'mailto:pedrini.mariano96@gmail.com',
  },
];
const SocialMedia = (props) => {
  const [socialFade, setSocialFade] = useState({
    fade: 'fade-out',
    position: 'from-left',
  });
  useEffect(() => {
    const timeout = setInterval(() => {
      if (socialFade.fade === 'fade-out') {
        setSocialFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 200);
    return () => clearInterval(timeout);
  }, [socialFade]);

  return (
    <div
      className={`social-container ${socialFade.fade} ${socialFade.position}`}
    >
      {socialMedia.map((each, key) => {
        return (
          <SocialMediaItem
            key={key}
            img={each.img}
            alt={each.alt}
            url={each.url}
          />
        );
      })}
    </div>
  );
};

export default SocialMedia;
